/**
 * @flow
 * @relayHash 503e8b1149ab8d19c732cef2e550d418
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type randomizePickemAnswerInput = {|
  randomizePickemAnswerInput?: ?randomizePickemAnswerInputType,
  clientMutationId?: ?string,
|};
export type randomizePickemAnswerInputType = {|
  game_id: string,
  event_id: string,
  guest_id: string,
  quarter_id: string,
  last_quarter?: ?boolean,
|};
export type randomizePickemAnswerMutationVariables = {|
  input: randomizePickemAnswerInput
|};
export type randomizePickemAnswerMutationResponse = {|
  +randomizePickemAnswer: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?$ReadOnlyArray<?{|
      +_id: ?string,
      +question_id: ?string,
      +guest_id: ?string,
      +game_id: ?string,
      +quarter_id: ?number,
      +answer: ?string,
      +correct_answer_count: ?number,
      +is_tiebreaker: ?boolean,
    |}>,
  |}
|};
export type randomizePickemAnswerMutation = {|
  variables: randomizePickemAnswerMutationVariables,
  response: randomizePickemAnswerMutationResponse,
|};
*/


/*
mutation randomizePickemAnswerMutation(
  $input: randomizePickemAnswerInput!
) {
  randomizePickemAnswer(input: $input) {
    code
    message
    data {
      _id
      question_id
      guest_id
      game_id
      quarter_id
      answer
      correct_answer_count
      is_tiebreaker
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "randomizePickemAnswerInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "randomizePickemAnswer",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "randomizePickemAnswerPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "pickemAnswerDataType",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "question_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "guest_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "game_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "quarter_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "answer",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "correct_answer_count",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "is_tiebreaker",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "randomizePickemAnswerMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "randomizePickemAnswerMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "randomizePickemAnswerMutation",
    "id": null,
    "text": "mutation randomizePickemAnswerMutation(\n  $input: randomizePickemAnswerInput!\n) {\n  randomizePickemAnswer(input: $input) {\n    code\n    message\n    data {\n      _id\n      question_id\n      guest_id\n      game_id\n      quarter_id\n      answer\n      correct_answer_count\n      is_tiebreaker\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bc5df8f626e8dba7d1ae0faee036f4a2';
module.exports = node;
